// Pre-compiled constructors for faster type checking
const stringConstructor = "test".constructor;
const arrayConstructor = [].constructor;
const objectConstructor = ({}).constructor;
const booleanConstructor = true.constructor;

// Pre-compiled regex patterns for better performance
const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const URL_REGEX = /^https?:\/\/.+/i;

// Memoization cache for repeated type checks
// Using Map for primitives and WeakMap for objects
const primitiveCache = new Map();
const objectCache = new WeakMap();

const isValidUrl = (urlString) => {
    return URL_REGEX.test(urlString);
}

export const isValidUUID = (uuid) => {
    return UUID_REGEX.test(uuid);
}

export const CheckType = (object) => {
    // Early returns for null/undefined
    if (object === null) return "null";
    if (object === undefined) return "undefined";
    
    // Check cache first for repeated values
    const isObject = typeof object === 'object' && object !== null;
    const cache = isObject ? objectCache : primitiveCache;
    
    if (cache.has(object)) {
        return cache.get(object);
    }
    
    let result;
    
    // Optimized constructor checks with early returns
    if (object.constructor === stringConstructor) {
        if (isValidUUID(object)) {
            result = "UUID";
        } else if (isValidUrl(object)) {
            result = "Url";
        } else {
            result = "String";
        }
    } else if (object.constructor === booleanConstructor) {
        result = "Boolean";
    } else if (object.constructor === arrayConstructor) {
        result = "Array";
    } else if (object.constructor === objectConstructor) {
        result = "Object";
    } else {
        result = "don't know";
    }
    
    // Cache the result for future lookups
    cache.set(object, result);
    return result;
}

